import { useState, useEffect, createContext, useContext } from "react";
import { sessionStorageUtil } from "../utils/storage";
import { useAuth } from "./AuthContext";
import { getAmcCode } from "../services/amc.service";
import retryApi from "../utils/api";

const AmcContext = createContext({
  amcCode: null,
  loading: true,
  error: false,
});

export const AmcProvider = ({ children }) => {
  const [amcCode, setAmcCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const { user } = useAuth();

  useEffect(() => {
    if (!amcCode) {
      const isGuest = user ? false : true;

      const getAmcCodeInContext = async () => {
        try {
          const res = await retryApi((signal) => getAmcCode(isGuest));

          console.log(res);

          if (res?.error) {
            throw new Error(res?.message || "Unable to get data from server.")
          }

          if (!res?.data) {
            throw new Error(res?.message || "Unable to get data from server.")
          }

          sessionStorageUtil.setAmcCode(res?.data);
          setAmcCode(res?.data)

        } catch (e) {
          console.log(e);

          setError(true);

        } finally {
          setLoading(false);
        }
      }

      getAmcCodeInContext();

    } else {
      setLoading(false);
    }
  }, [amcCode]);

  // if (loading) {
  //   return (
  //     <div className='container-fluid p-0'>
  //       <div
  //         className='row w-100 mx-auto flex-column justify-content-center align-items-center gap-sm-2 flex-nowrap'
  //         style={{
  //           minHeight: "100dvh",
  //           overflow: "hidden",
  //           padding: "8px",
  //           background: "linear-gradient(90deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)",
  //           // background:
  //           //   theme === "dark"
  //           //     ? "linear-gradient(90deg, var(--theme-dark-primary) 0%, var(--theme-dark-secondary) 100%)"
  //           //     : "linear-gradient(90deg, var(--theme-light-primary) 0%, var(--theme-light-secondary) 100%)",
  //         }}
  //       >
  //         <div
  //           dir="ltr"
  //           className='col-auto p-0 p-4 rounded-4 d-flex flex-column row-gap-3 align-items-center justify-content-center'
  //           style={{
  //             backgroundColor: "rgba(255,255,255,.45)",
  //             boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
  //             minHeight: "200px",
  //             minWidth: "240px",
  //           }}
  //         >
  //           <div dir="ltr" className='loader'></div>
  //           <div dir="ltr" className='loader-text ps-2'></div>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }

  return <AmcContext.Provider value={{ amcCode, loading, error }}>{children}</AmcContext.Provider>;
};

export const useAmc = () => {
  return useContext(AmcContext);
};
